import { FilterCogOutlineIcon } from './FilterCogOutlineIcon';

/**
 * author: Simran
 * id 6E54B42B-896D-4598-83D7-96E592B1B15F
 * name filter-cog-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-cog-outline.svg
 * tags
 * - Settings 
 */
export const FunnelSettingsOutlineIcon = FilterCogOutlineIcon;
export default FunnelSettingsOutlineIcon